// @ts-nocheck
import {
    addToChainAfter,
    ExtractHandlerParameter,
    ExtractHandlerProps,
    replaceInChain,
} from "@toolkit/Modules/client-framework/HandlerCreator";
import {
    PopulateApiParameter,
    RequestDataFromApi,
    chain,
} from "@insite/client-framework/Store/Data/Invoices/Handlers/LoadInvoiceByInvoiceNumber";
import { getInvoice } from "@insite/client-framework/Services/InvoiceService";

type HandlerChainType = typeof PopulateApiParameter;

export interface PopulateApiParameterParameters extends ExtractHandlerParameter<HandlerChainType> {
    additionalExpands?: string[];
}

export interface PopulateApiParameterProps extends ExtractHandlerProps<HandlerChainType> {}

addToChainAfter<PopulateApiParameterParameters, PopulateApiParameterProps>(chain, PopulateApiParameter, props => {
    if (props.parameter.additionalExpands) {
        props.apiParameter = {
            ...props.apiParameter,
            additionalExpands: props.parameter.additionalExpands,
        };
    }
});

replaceInChain(chain, RequestDataFromApi, async props => {
    try {
        props.apiResult = await getInvoice(props.apiParameter);
    } catch (error) {
        if (
            "status" in error &&
            (error.status === 400 ||
                error.status === 404 ||
                error.status === 401) /* Store Custom Code - 401 is Unauthorized Access */
        ) {
            const status = error.status === 401 ? 401 : 404; // Store Custom Code
            props.dispatch({
                type: "Data/Invoices/FailedToLoadInvoiceByInvoiceNumber",
                invoiceNumber: props.parameter.invoiceNumber,
                status, // Store Custom Code
            });
            return false;
        }
        throw error;
    }
});
